const messages = {
    "ACCOUNT_SUM": "Konto",
    "ADD_MEMEBER_FAILED": "Lägg till medlem misslyckades. Orsak: {Message}",
    "ADD_ORIGINATOR_FAILED": "Lägg till initiativtagare misslyckades. Orsak: Initiativtagare har redan lagts till!",
    "APPLICATION MANUAL": "Användarmanual",
    "APP_BANNER_DESC": "Kontinuerligt förbättrande processen strävar till att ta tillvara idéer från personalen för att inkludera alla att utveckla företagets arbetsmiljö och processer. Detta vertyg är till för att skapa och handha initiativ och kontinuerlit förbättrande förslag.",
    "APP_NAME": "Wärtsilä Kontinuerligt Förbättrande handlingssystem",
    "ASK_EXPERT_OPINIONS": "E-post har skickats!",
    "ATTACH_FILES_HELP": "Lägg till fil(er)",
    "Account": "Konto",
    "Active": "Aktiv",
    "Add": "Lägg till",
    "Add comment or opinion": "Lägg till kommentar eller åsikt",
    "Add new initiative type": "Lägg till ny initiativ typ",
    "Admin": "Administratör",
    "All": "Alla",
    "Amount": "Mängd",
    "Approve": "Godkänd",
    "Ask expert opinion": "Begär expert utlåtande",
    "Attach files": "Lägg till bilaga",
    "Attached files": "Bifogade bilagor",
    "Author": "Upphovsman",
    "BROWSE": "BLÄDDRA",
    "Browse CI-Proposals": "Bläddra KF-förslaget",
    "Browse Initiatives": "Bläddra initiativ",
    "Browse old Initiatives and CI-Proposals": "Bläddra gamla initiativ och KF-förslag",
    "CI Proposal created": "KF-förslag skapat",
    "CI-Proposal": "KF-förslag",
    "CIP": "utvecklingsidé",
    "CIP Group": "KF-Grupp",
    "CIP Id": "KF #",
    "CIP Groups": "KF-Grupper",
    "CIP-GROUPS": "KF-GRUPPERNA",
    "CIP-Group": "KF-Grupp",
    "CIP.CI_GROUP.HELP": "Välj din egen KF-Grupp.",
    "CIP.NAME.HELP": "Skriv ditt namn i fältet. Välj ditt namn från listan. Om ditt namn/SAP-nummer är inte på listan kontakta Juha Jaakkola juha.jaakkola@wartsila.com.",
    "CIP.PROPOSAL.HELP": "Beskriv förbättringsförslaget.",
    "CIP.TITLE.HELP": "Ge förslaget en beskrivande rubrik.",
    "CIP_DESC": "Kontinuerlig Förbättring är ett lokalt sätt att förbättra arbetsomgivningen i grupp. Med KF kan du utveckla t.ex. Ordningen eller din egen arbetsmiljö, arbetssätt, arbetssäkerhet och trivsel.",
    "CIP_FULL": "KF-Förslag",
    "CONTINUOUS IMPROVEMENT": "KONTINUERLIGT FÖRBÄTTRANDE",
    "CREATE CONTINUOUS IMPROVEMENT": "GÖR KF-FÖRSLAG",
    "CREATE INITIATIVE": "GÖR INITIATIV",
    "CURRENT_SITUATION": "Nuvarande situation",
    "CURRENT_SITUATION_HELP": "Beskriv nuvarande situation.",
    "Clear": "Töm",
    "Coach name": "Coach",
    "Comment": "Kommentar",
    "Cost center": "Kostnadsställe",
    "Created": "Skapad",
    "Created by": "Skapad av",
    "Created date": "Skapad datum",
    "DEPOSIT_WITHDRAW_AMOUNT": "Summa att lägga till/ta bort",
    "Department": "Avdelning",
    "Deposit": "Insättning",
    "Deposit or withdraw money": "Sätt in eller ta ut summa för KF-gruppen",
    "Description": "Beskrivning",
    "Display Name": "Visa namnet",
    "Domain": "Domain",
    "Email": "Email",
    "Email sent": "Email skickat",
    "Error": "Fel",
    "Euro": "Euro",
    "Euros": "Euron",
    "Expert Opinion": "Expert utlåtande",
    "FOCUS Users": "FOCUS användare",
    "Failed": "Misslyckades",
    "Filter": "Filtrera",
    "GOOD TO KNOW": "BRA ATT VETA",
    "Group members": "Gruppens medlemmar",
    "Group transactions": "Gruppens transaktioner",
    "HOME": "STARTSIDA",
    "Hide reward calculator": "Göm belöningsräknaren",
    "How to use this application": "Hur du ska använda den här systemet",
    "IMPROVEMENT_PROPOSAL": "Förbättringsförslag",
    "IMPROVEMENT_PROPOSAL_HELP": "Beskriv ditt förbättringsförslag.",
    "INITIATIVE": "INITIATIV",
    "INITIATIVE_DESC": "Initiativ är ett personligt utvecklingsförslag, som innehåller en lösning som det går att räkna en ekonomisk besparing för företaget.",
    "INITIATIVE_NAME": "Initiativets namn",
    "INITIATIVE_NAME_HELP": "Ge en beskrivande rubrik åt ditt initiativ.",
    "INITIATIVE_TYPE_HELP": "Välj initiativ typ.",
    "Id": "Id",
    "Idea originator": "Författare",
    "Ideas": "Idéer",
    "In review": "Förhandsvisning",
    "Initiative Types": "Initiativtyper",
    "Initiative created": "Förslaget skapat",
    "Initiative reassigned to:": "Förslaget omdirigeras till: ",
    "Initiative type with same title exists.": "Förslag med samma titel finns redan.",
    "Initiatives": "Initiativ",
    "Is Active": "Aktiv",
    "Is Admin": "Huvudanvändare",
    "Journals": "Händelser",
    "LOCAL IDEAS": "SE IGENOM IDEÈR",
    "LOCALE_en": "ENGLISH-EN",
    "LOCALE_en-EN": "ENGLISH-EN",
    "LOCALE_en-US": "ENGLISH-EN",
    "LOCALE_fi": "SUOMI-FI",
    "LOCALE_fi-FI": "SUOMI-FI",
    "LOCALE_sv": "SVENSKA-SV",
    "LOCALE_sv-SE": "SVENSKA-SV",
    "Last 30 Days": "Föregående 30 dagar",
    "Last 7 Days": "Föregående 7 dagar",
    "Last Month": "Föregående månad",
    "MANAGE IDEAS": "HANDHA IDÈER",
    "Make decision": "Gör beslut",
    "Manager": "Manager",
    "Modified": "Modifierad",
    "NAME_HELP": "Skriv ditt namn i fältet. Välj ditt namn från listan. Om ditt namn/SAP-nummer är inte på listan kontakta Juha Jaakkola juha.jaakkola@wartsila.com. Fyll i din information även om du lämnar in den anonymt.",
    "NEW_CI-GROUP-CREATED": "Ny KF-grupp skapad:#{Id}",
    "NEW_INITIATIVE_TYPE_ADDED": "Ny initiativ typ adderad",
    "NO_DATA": "Ingen data finns ...",
    "Name": "Namn",
    "New": "Ny",
    "Next": "Följande",
    "New initiative type is added": "Ny initiativ typ adderad",
    "No name selected": "Inget namn valt",
    "Not Active": "Inte aktiv",
    "Not admin": "Inte huvudanvändare",
    "Open": "Öppet",
    "Paid": "Betalt",
    "Pending": "Väntar",
    "Please select a name and click": "Välj ett namn och tryck",
    "Previous": "Föregående",
    "Print": "Skriv ut",
    "Proposal": "Förslag",
    "REASSIGN_OK": "Initiativets omdirigering lyckades !",
    "REPORT_ANONYMOUS": "Jag vill lämna mitt förslag anonymnt",
    "REWARD.EFFECTIVENESS": "Effektiv kostnadsbesparing (Genomloppstid, omsättningshastighet).",
    "REWARD.EFFECTIVENESS_COL1": "En mera kostnadseffektiv lösning. Snabbare genomloppstid för arbetsmomentet. T.ex. Arbetsmomentets förbättring eller besparing ca. 500 - 1000 € per år.",
    "REWARD.EFFECTIVENESS_COL2": "Snabbare genomloppstid eller borttagande av onödiga arbetsmoment. Utveckling av maskinbearbetning eller montering eller besparingar på 1000 - 5000 € per år.",
    "REWARD.EFFECTIVENESS_COL3": "Minskar slutproduktens eller delmonteringens genomloppstid markant eller besparingar på 5000 - 50000 € per år.",
    "REWARD.EFFECTIVENESS_COL4": "Exceptionellt stora besparingar i produktens livcykel eller stora besparingar i t.ex. Services metoder. Eller besparingar > 50000 € per år.",
    "REWARD.ENVIRONMENT": "Omgivning",
    "REWARD.ENVIRONMENT_COL1": "Material eller energi användningen minskar. / Mängden vanligt avfall minskar.",
    "REWARD.ENVIRONMENT_COL2": "Minskar markant materialåtgången och energiförbrukningen på avdelningen / Minskar mängden farligt avfall (t.ex. Oljeavfall) / Minskar avfallsmängderna markant.",
    "REWARD.ENVIRONMENT_COL3": "Minskar markant miljörisker. Minskar markant fabrikens föroreningar.",
    "REWARD.ENVIRONMENT_COL4": "Förbättringsförslag, som kan användas i många av Wärtsilä enheter för att minska föroreningar, energi- och materialåtgång (incl. kemikalier), eller för att minska avfall.",
    "REWARD.GLOBAL": "Global",
    "REWARD.OWN_BUSINESS_UNIT": "Affärsenhet",
    "REWARD.OWN_DEPARTMENT": "Egen avdelning",
    "REWARD.OWN_STATION": "Egen arbetspunkt",
    "REWARD.QUALITY": "Kvalité",
    "REWARD.QUALITY_COL1": "Liten kvalitétsförbättring vid den egna arbetspunkten. T.ex. Förbättra oklara instruktioner.",
    "REWARD.QUALITY_COL2": "Kvalitétsförbättring för den egna avdelningen. T.ex. Utvecklar arbetsmoment, som minskar och förhindrar kvalitétsproblem från att uppstå.",
    "REWARD.QUALITY_COL3": "Minskar och förhindrar kvalitétsproblem inom affärsenheten. / Innovation som markant färbättrar produkt/process kvalité.",
    "REWARD.QUALITY_COL4": "En lösning som minskar eller förhindrar kvalitetsproblem från att upstå som har varit ett långvarigt problem globalt för en lång tid / En markant innovation.",
    "REWARD.SAFETY": "Arbetssäkerhet",
    "REWARD.SAFETY_COL1": "Liten arbetssäkerhetsförbättring vid den egna arbetspunkten som berör verktyg, arbetsmetoder eller omgivning.",
    "REWARD.SAFETY_COL2": "Säkerhetsförbättring som minskar exponeringen för kemikalier eller annat, eller som gör en markant skillnad för ergonomin / Säkerhetsförbättring som minskar risken för olyckor.",
    "REWARD.SAFETY_COL3": "Minskar och förhindrar arbetsolyckor eller sjukfrånvaro från att uppstå vid affärsenheten. Förbättrar markant arbetssäkerhet och arbetshälsa.",
    "REWARD.SAFETY_COL4": "Minskar arbetsolyckor eller sjukfrånvaro i flera av Wärtsiläs enheter / Innovation som globalt förbättrar arbetssäkerhet eller arbetshälsa.",
    "REWARD_CONSULTED": "Jag har konsulterat initiativgivaren.",
    "REWARD_SENT": "Jag har skickat belöningsformuläret till SD Worx och till initiativkommittéens sekreterare.",
    "Ready": "Klar",
    "Reassign": "Omdirigera",
    "Reassign to different person": "Omdirigera åt annan person",
    "Rejected": "Förkastat",
    "Remove": "Avlägsna",
    "Request for expert opinion:": "Begäran om expertutlåtande: ",
    "Responsible person": "Ansvarig person",
    "Reward sum": "Belöning",
    "Rewarded with amount:": "Belönad med: ",
    "Rewarding form": "Belöning",
    "Rewarding template": "Belönings mall",
    "Rules": "Regler",
    "SAP Number": "SAP-Nummer",
    "SAVE_CI-GROUP-OK": "KF-grupp sparad",
    "SAVE_CIP_OK": "Save CI-Proposal successfully!",
    "SAVE_DECISION_OK": "Decision was saved successfully!",
    "SAVE_INITIATIVE_FAILED": "Failed to save initiative!",
    "SAVE_INITIATIVE_OK": "Initiative was saved successfully!",
    "SAVE_INITIATIVE_TYPE_OK": "Initiativ typen har sparats!",
    "SAVE_REWARD_OK": "Belöning sparad!",
    "SEARCH": "SÖK",
    "SEE_YOU_AGAIN": "Utloggningen lyckades! Tack och på återseende!",
    "SEND_TO_COMMITTEE": "Jag vill att initiativet behandlas enligt det nya systemet.",
    "Save": "Spara",
    "Save Draft": "Spara utkastet",
    "Save and send": "Spara och skicka",
    "Select": "Välj",
    "Select an initiative type here": "Välj initiativ typ.",
    "Show reward calculator": "Visa belöningsberäknare",
    "Sign in again": "Logga in igen",
    "State": "Status",
    "Status": "Status",
    "Success": "Lyckades",
    "TASK_WARNING": "Du {value} har en ny uppgift.",
    "INITIATIVE_WARNING": "{value} ny initiativ.",
    "IDEAS_WARNING": "{value} ny KF-förslag",
    "OPINION_WARNING": "{value} öppna opinionsförfrågningar",
    "TRANSACTION_FAIL": "Transaktionen misslyckades. Orsak: {Message}",
    "TRANSACTION_OK": "Transaktionen utförd!",
    "Thank you": "Tack!",
    "This Month": "Denna månad",
    "This Year": "Detta år",
    "Title": "Titel",
    "Title_FI": "Titel FI",
    "Title_EN": "Titel EN",
    "Title_SV": "Titel SV",
    "To continue, please select a name and click": "För att fortsätta, välj ett namn och tryck",
    "Toggle table filter": "Visa/göm filter",
    "Type": "Typ",
    "USERS": "ANVÄNDARE",
    "USER_ALREADY_IN_GROUP": "Användaren är redan medlem av gruppen!",
    "User": "Användare",
    "User with same account exists.": "Användarkonto finns redan.",
    "WELCOME": "Välkommen",
    "Waiting For Commitee": "Väntar på kommittén beslut",
    "Waiting To Be Implemented": "Väntar på implementering",
    "Withdraw": "Ta bort summan",
    "YEAR": "år",
    "You can browse existing CI-Proposals": "Du kan bläddra bland existerande KF-förslag",
    "You can browse existing Initiatives": "Du kan bläddra bland existerande initiativ",
    "initiative(s)": "initiativ",
    "Send emails": "Skicka e-mail",
    "Country": "Land",
    "MANUAL_URL": "https://fiidm01.wnsd.com/kronodoc/1502/GetLatest/9148861/FOCUS%202.0%20SVE%20Manual.pptx",
    "FOCUS_INDICATORS": "Focus mätare",
    "LINKS_HEADER": "LÄNKAR"
};

export default messages;



// WEBPACK FOOTER //
// ./locales/sv.js